module.exports = __webpack_public_path__ + "static/media/bootstrap.e0ba2ed1.svg";